export default __webpack_public_path__ + "static/media/bbb.b29c13b7.png";